import styled from 'styled-components';
import Icon from '../../assets/images/mobile-icon.svg';

const PhoneIcon = styled.span`
    background: url("${Icon}") no-repeat left center;
    background-size: 28px 28px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    height: 28px;
    width: 28px;
}`;

export default PhoneIcon;
